export const PLATFORM_MAC = "mac";
export const PLATFORM_WINDOWS = "windows";
export const PLATFORM_OTHER = "other";

export function detectPlatform() {
    const value = navigator.userAgentData?.platform || navigator.platform || navigator.userAgent || "";

    if (/Mac|iPhone|iPad|iPod/i.test(value)) return PLATFORM_MAC;
    if (/Win/i.test(value)) return PLATFORM_WINDOWS;

    return PLATFORM_OTHER;
}

export function isMacPlatform() {
    return detectPlatform() === PLATFORM_MAC;
}

export function commandKeyLabel() {
    return isMacPlatform() ? "⌘" : "Ctrl";
}
